import { render, staticRenderFns } from "./personalAdd.vue?vue&type=template&id=38e3d93b&scoped=true"
import script from "./personalAdd.vue?vue&type=script&lang=js"
export * from "./personalAdd.vue?vue&type=script&lang=js"
import style0 from "./personalAdd.vue?vue&type=style&index=0&id=38e3d93b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3d93b",
  null
  
)

export default component.exports